module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0047.png.2ca00b01.jpg";